// utils/formatDate.ts
import dayjs from "dayjs";

export const formatDateUS = (date: string | Date): string => {
  return dayjs(date).format("MM/DD/YYYY");
};

export const formatTime = (date: string | Date): string => {
  return dayjs(date).format("HH:mm");
};
